// extracted by mini-css-extract-plugin
export default {"videoModal":"hux1wMACdYN38k6ZisvP","videoBox":"mfxkc0s4rl23U_2uRF0W","closeBtn":"FzVDVI448fvDlcSYY3kJ"};